import { render } from "./CocktailIcon.vue?vue&type=template&id=33e2d64b"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CocktailIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33e2d64b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33e2d64b', __exports__)) {
    api.reload('33e2d64b', __exports__)
  }
  
  module.hot.accept("./CocktailIcon.vue?vue&type=template&id=33e2d64b", () => {
    api.rerender('33e2d64b', render)
  })

}


export default __exports__